const INFO = {
	main: {
		title: "Rifat - Full Stack Developer",
		name: "H. M. Jabed Omur Rifat",
		email: "jabedomur.rifat@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		twitter: "https://twitter.com/",
		github: "https://github.com/omurRifat",
		linkedin: "https://www.linkedin.com/in/omurrifat/",
		instagram: "https://instagram.com/",
		stackoverflow: "https://stackoverflow.com/",
		facebook: "https://www.facebook.com/OmurRifat/",
	},

	homepage: {
		title: "Hey, This is H. M. Jabed Omur Rifat",
		description:
			"I am highly disciplined, and a quick learner. I am passionate about enhancing and developing my skills and making sure my projects are best fitted. You'll find me hardworking, always seeking improvement and betterment, and fiercely ambitious.",
	},

	about: {
		title: "I’m Tharindu N. I live in Sri Lanka, where I design the future.",
		description:
			"I've worked on a variety of projects over the years and I'm proud of the progress I've made. Many of these projects are open-source and available for others to explore and contribute to. If you're interested in any of the projects I've worked on, please feel free to check out the code and suggest any improvements or enhancements you might have in mind. Collaborating with others is a great way to learn and grow, and I'm always open to new ideas and feedback.",
	},

	articles: {
		title: "I'm passionate about pushing the boundaries of what's possible and inspiring the next generation of innovators.",
		description:
			"Chronological collection of my long-form thoughts on programming, leadership, product design, and more.",
	},

	projects: [
		{
			title: "Organization Manager",
			description:
				"The organization manager's goal is to make a system for the Non-Profit Social Organization, where all activities will be automated by the system, and man’s power dependency will not be the major issue for their organizational activity, which will make the organization much more active.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "Code Resources",
			link: "https://github.com/OmurRifat/organization-manager",
			liveSite: "https://organization-manager.vercel.app/",
		},
		{
			title: "Book Store",
			description:
				"This is an online book store, Here you find all types of books including international books. I always tries to make the website significantly user-friendly. I hope you enjoy your journey with Book Store.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "Code Resources",
			link: "https://github.com/OmurRifat/book-store-client",
			liveSite: "https://book-store-36.web.app/",
		},
		{
			title: "Dynamic Form",
			description:
				"This is a simple form connected to the database. Here all the data are imported from the database. Simple & cool look have implemented by tailwind CSS.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "Code Resources",
			link: "https://github.com/OmurRifat/dynamic-form",
			liveSite: "https://dynamic-form-01.web.app/",
		},

		{
			title: "Cam Finder",
			description:
				"This is a online camera resaling store, Here you find all types of used Camera including most premium also. Our Team always try to make the website signeficently user frendly. Hope you enjoy you journey with Cam-Finder",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "Code Resources",
			link: "https://github.com/OmurRifat/Cam-Finder",
			liveSite: "https://cam-finder.web.app/",
		},


	],
};

export default INFO;
